import { Regions } from "../data/regions";

/**
 * Gets the display name for a country within a specific region.
 *
 * @param regionName - The name of the region (e.g., "Europe", "Africa")
 * @param countryCode - The ISO country code (e.g., "AL", "DZ")
 * @returns The display name of the country, or the country code if not found
 *
 * @example
 * getCountryDisplayName("Europe", "AL"); // Returns "Shqipëri"
 * getCountryDisplayName("Africa", "DZ"); // Returns "Algérie"
 */
export const getCountryDisplayName = (
  regionName: string,
  countryCode: string
): string => {
  const region = Regions.find((r) => r.name === regionName);

  if (!region) {
    return countryCode;
  }

  const country = region.countries.find((c) => c.code === countryCode);

  if (!country) {
    return countryCode;
  }

  return country.displayName || country.name || countryCode;
};
